import { createFileRoute } from "@tanstack/react-router";
import { PropertyForm } from "@/components/admin/PropertyForm";

export const Route = createFileRoute("/_authenticated/admin/propiedades/$id")({
  head: () => ({ meta: [{ title: "Editar propiedad — Admin" }] }),
  component: EditPage,
});

function EditPage() {
  const { id } = Route.useParams();
  return <PropertyForm mode="edit" propertyId={id} />;
}
